<!--
 * @Author: tony.zhu
 * @Date: 2025-02-07 13:47:23
 * @LastEditTime: 2025-03-05 10:15:27
 * @LastEditors: tony.zhu
 * @Description: 
-->
<template>
  <div class="basic_plugin_code_notice">
    <p>{{$t('widgets_basic_plugin_code_components_notice_2730')}}</p>
    <p>{{$t('widgets_basic_plugin_code_components_notice_2731')}}</p>
    <div v-if="false" class="flex_center_center flex_j_s">{{$t('widgets_basic_plugin_code_components_notice_2732')}}<el-tooltip
        class="item"
        effect="light"
        placement="bottom-end"
        :visible-arrow="false"
        v-model="isShow"
      >
        <template #content>
          <img
            :src="isShow ? '/static/image/m_plugin_code_advSetting.gif' : '/static/image/m_plugin_code_advSetting_static.png'"
            class="basic_plugin_code_notice_content_img"
          />
        </template>
        <span class="cursor_p">{{$t('widgets_basic_plugin_code_components_notice_2733')}}</span>
      </el-tooltip>{{$t('widgets_basic_plugin_code_components_notice_2734')}}</div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'basic_plugin_code_notice',
  data () {
    return {
      isShow: false
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_plugin_code_notice {
  font-size: 13px;
  color: #666;
  line-height: 28px;
  margin: 0 0 16px 0;
  > p {
    word-break: auto-phrase;
  }
  span {
    text-decoration: underline;
    color: #4a67d1;
    padding: 0 3px;
  }
}
</style>

<style>
.basic_plugin_code_notice_content_img {
  max-width: 270px;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/widgets/basic_plugin_code/components/notice.vue